
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import BeneficiaryNominationChart from "@/superannuation/BeneficiaryNominationChart.vue"
import SsComponentPage from "@/report/pages/SsComponentPage.vue"

@Component({
  name: "SsBeneficiaryPage",
  components: {
    SsComponentPage,
    BeneficiaryNominationChart,
  },
})
export default class SsBeneficiaryPage extends AbstractPage {}
